module.exports = __webpack_public_path__ + "img/review-grid-section-04.e2e43e1f.png";